import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/site";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            nav("/admin");
        } catch (err) {
            setError(err?.response?.data?.detail || "Credenciales inválidas");
        } finally {
            setLoading(false);
        }
    };

    const inputCls = "w-full bg-white border border-white/20 focus:border-madera rounded-xl outline-none py-3.5 px-4 text-white placeholder:text-white/40 transition-colors";

    return (
        <div className="min-h-screen hero-gradient flex items-center justify-center px-5">
            <div className="w-full max-w-md">
                <img src={LOGO.white} alt="Maderas La Romanilla" className="h-12 mx-auto mb-10" />
                <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-8 md:p-10">
                    <div className="flex items-center gap-3 mb-8">
                        <Lock size={20} className="text-madera" />
                        <h1 className="font-display font-bold text-2xl text-white">Panel de administración</h1>
                    </div>
                    <form onSubmit={submit} className="space-y-4">
                        <input data-testid="admin-email" type="email" className={inputCls.replace('bg-white','bg-white/5')} placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} />
                        <input data-testid="admin-password" type="password" className={inputCls.replace('bg-white','bg-white/5')} placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
                        {error && (
                            <p role="alert" data-testid="admin-login-error" className="text-sm text-white bg-destructive/80 rounded-lg px-4 py-3">{error}</p>
                        )}
                        <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-naranja text-white rounded-full py-4 font-semibold hover:bg-naranja-dark transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
                            {loading ? <Loader2 size={16} className="animate-spin" /> : "Ingresar"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
